import { LatLngBounds, LatLng } from "leaflet";

export class Location {

  latlng: LatLng;
  ADRESSE: string;
  viewBounds: LatLngBounds;

}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/location.ts